import React, { useEffect, useState } from 'react';
import './Contact.css';
import { apiService, ContactInfo } from '../services/api';
import PageLoader from './PageLoader';

const Contact: React.FC = () => {
  const [contactInfo, setContactInfo] = useState<ContactInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await apiService.getContact();
        setContactInfo(data);
      } catch (err) {
        console.error('Failed to fetch contact info:', err);
        setContactInfo(null);
        setError(err instanceof Error ? err.message : 'Failed to load contact information.');
      } finally {
        setLoading(false);
      }
    };

    fetchContactInfo();
  }, []);

  return (
    <div className="contact">
      <div className={loading ? 'contact-content' : 'contact-content page-content-enter'}>
        {loading ? (
          <PageLoader label="Loading contact" />
        ) : error ? (
          <p className="p1">{error}</p>
        ) : !contactInfo ? (
          <p className="p1">Contact information is unavailable.</p>
        ) : (
          <>
            {contactInfo.introduction ? (
              <p className="p1" style={{ whiteSpace: 'pre-line' }}>
                {contactInfo.introduction}
              </p>
            ) : null}

            {contactInfo.contact_list.map((item, index) => (
              <p className="p1" key={`${item}-${index}`} style={{ whiteSpace: 'pre-line' }}>
                {item}
              </p>
            ))}

            {contactInfo.image_list.length > 0 ? (
              <p className="p1">
                <b>Follow us</b>
                <br />
                {contactInfo.image_list.map((image, index) => (
                  <img
                    key={`${image}-${index}`}
                    className="qrCode"
                    src={image}
                    alt={`${contactInfo.name || 'Artizim'} ${index + 1}`}
                    referrerPolicy="no-referrer"
                  />
                ))}
              </p>
            ) : null}
          </>
        )}
      </div>

      <p className="web-design">Design,Development,And identity for Your product.</p>
    </div>
  );
};

export default Contact;
